import { Link } from "react-router-dom";
import { openContactForm } from "@/lib/contactForm";
import {
  CAPABILITIES_PATH,
  CAPABILITIES_RETURN_STATE,
  isCapabilitiesOutbound,
  markFromCapabilities,
  useCapabilitiesReturn,
} from "@/lib/knowledgeReturn";
import "./knowledgeNav.css";

export function CapLink({ to, className, children, ...rest }) {
  const outbound = isCapabilitiesOutbound(to);
  return (
    <Link
      to={to}
      className={className}
      state={outbound ? CAPABILITIES_RETURN_STATE : undefined}
      onClick={() => {
        if (outbound) markFromCapabilities(to);
      }}
      {...rest}
    >
      {children}
    </Link>
  );
}

export function CapabilitiesReturnLink() {
  const show = useCapabilitiesReturn();
  if (!show) return null;
  return (
    <div className="ds-know-hero-nav ds-know-hero-nav--return">
      <KnowledgeBack href={CAPABILITIES_PATH} label="Capabilities" testId="capabilities-return" />
    </div>
  );
}

export function KnowledgeBack({ href, label, testId = "knowledge-back" }) {
  if (!href || !label) return null;
  return (
    <Link className="ds-know-back" to={href} data-testid={testId} aria-label={`${label} 목록으로`}>
      <span className="ds-know-back__arrow" aria-hidden="true">←</span>
      <span className="ds-know-back__label">{label}</span>
    </Link>
  );
}

export function KnowledgeHeroNav({ backHref, backLabel, crumbs = [] }) {
  if (!backHref && !crumbs.length) return null;
  return (
    <div className="ds-know-hero-nav">
      <KnowledgeBack
        href={backHref}
        label={backLabel}
        testId={backLabel === "Capabilities" ? "capabilities-return" : "knowledge-back"}
      />
      <KnowledgeBreadcrumb items={crumbs} />
    </div>
  );
}

export function KnowledgeBreadcrumb({ items = [] }) {
  if (!items.length) return null;
  return (
    <nav className="ds-know-crumbs" aria-label="breadcrumb" data-testid="knowledge-breadcrumb">
      {items.map((item, index) => {
        const last = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`}>
            {index > 0 ? <span aria-hidden="true"> / </span> : null}
            {last || !item.href ? (
              <span>{item.label}</span>
            ) : (
              <Link to={item.href}>{item.label}</Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}

export function KnowledgePager({ prev, next, indexHref = "/guides", indexLabel = "Guide 전체보기" }) {
  return (
    <nav className="ds-know-pager" aria-label="이전 다음 가이드" data-testid="knowledge-pager">
      {prev?.path ? (
        <Link className="ds-know-pager__prev" to={prev.path}>
          ← {prev.title || "이전 글"}
        </Link>
      ) : (
        <span className="ds-know-pager__prev" />
      )}
      <Link className="ds-know-pager__index" to={indexHref}>
        {indexLabel}
      </Link>
      {next?.path ? (
        <Link className="ds-know-pager__next" to={next.path}>
          {next.title || "다음 글"} →
        </Link>
      ) : (
        <span className="ds-know-pager__next" />
      )}
    </nav>
  );
}

export function KnowledgeExplore({ heading = "이어서 보기", links = [], contact = true, fromCapabilities = false }) {
  const handleContact = (e) => {
    e.preventDefault();
    openContactForm();
  };
  if (!links.length && !contact) return null;
  const LinkCmp = fromCapabilities ? CapLink : Link;
  return (
    <section className="ds-know-explore" aria-label={heading}>
      <h2>{heading}</h2>
      <div className="ds-know-explore__row">
        {links.map((link) => (
          <LinkCmp key={link.href} to={link.href} className={link.active ? "is-active" : undefined}>
            {link.label}
          </LinkCmp>
        ))}
        {contact ? (
          <a className="ds-know-contact" href="/#contact" onClick={handleContact}>
            상담하기
          </a>
        ) : null}
      </div>
    </section>
  );
}

export function guideNeighbors(items, slug) {
  const list = items || [];
  const index = list.findIndex((row) => row.slug === slug);
  if (index < 0) return { prev: null, next: null };
  return {
    prev: list[index - 1] || null,
    next: list[index + 1] || null,
  };
}
